export const DATE = 'DATE';
export const VARCHAR = 'VARCHAR';
export const UMO_URL = 'UMO_URL';
export const LINK = 'LINK';
export const LOVCCENTRELIST = 'LOV CCENTRE LIST';
export const LOV = 'LOV';
export const CHECKBOX = 'CHECKBOX';
export const BOOLEAN = 'BOOLEAN';
export const RADIO = 'RADIO';
export const RICHTEXT = 'RICHTEXT';
export const RICH = 'RICH';
export const RGROUP = 'RGROUP';
export const SINGLE_REPEATING_FIELD = 'S';
